import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=2d839761&scoped=true&"
import script from "./carousel.ts?vue&type=script&lang=js&"
export * from "./carousel.ts?vue&type=script&lang=js&"
import style0 from "./carousel.less?vue&type=style&index=0&id=2d839761&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d839761",
  null
  
)

export default component.exports